import axios from 'axios'; // 1. 引入「原始」axios (供 refreshToken 使用)
// 2. 引入您在 interceptors.js 建立的「工廠函式」
import api from '@/js/interceptors';
import router from '@/router';

// 您的 API 基礎 URL
// 這會被傳遞給工廠函式，也會被原始 axios 呼叫使用
// const API_BASE_URL = 'http://127.0.0.1:8000/jwt';

export default {
  // 動作：登入
  async login({ commit }, config) {
    try {
      const res = await api.post('jwt/token', config);
      
      const { access, refresh } = res.data;
      
      // 1. [關鍵] 只需要 commit。
      //    您的 interceptors.js 會自動從 state 讀取這個新 token
      commit('SET_AUTH_DATA', {
        accessToken: access,
        refreshToken: refresh,
      });
      
      return res.data;
  
    } catch (error) {
      // 2. [關鍵] 只需要 commit。
      //    您的 interceptors.js 會因為 state 為空而自動停止發送 token
      commit('CLEAR_AUTH_DATA');
      
      // 3. 拋出錯誤讓組件知道
      console.error('Login failed:', error.response?.data || error.message);
      throw error;
    }
  },

  // 動作：登出
  logout({ commit }) {
    commit('CLEAR_AUTH_DATA');
    delete api.defaults.headers.common['Authorization'];
    router.push({ name: 'main' }); // 假設您的登入頁路由為 Login
  },

  // 動作：刷新 Access Token
  async refreshToken({ commit, state }) {
    // 檢查：如果 state 中已沒有 refresh token，直接登出
    if (!state.refreshToken) {
      console.warn('refreshToken Action 被呼叫，但 state 中沒有 token，強制登出');
      commit('CLEAR_AUTH_DATA');
      router.push({ name: 'main' });
      throw new Error('No refresh token to refresh');
    }
  
    try {
      const res = await axios.post(`jwt/token/refresh`, {
        refresh: state.refreshToken,
      });
  
      const { access } = res.data;
      
      commit('SET_AUTH_DATA', {
        accessToken: access,
        refreshToken: state.refreshToken
      });
      return access;
    } catch (error) {
      console.error('Token 刷新失敗, 執行登出:', error);
      commit('CLEAR_AUTH_DATA');
      router.push({ name: 'main' }); 
      throw error;
    }
  },

  async tryAutoLogin({ commit, dispatch }) {
    // 1. 從 localStorage 讀取 tokens
    const accessToken = localStorage.getItem('dc-access');
    const refreshToken = localStorage.getItem('dc-refresh');

    if (!accessToken || !refreshToken) {
      commit('CLEAR_AUTH_DATA');
      return;
    }

    commit('SET_AUTH_DATA', {
      accessToken: accessToken,
      refreshToken: refreshToken,
    });

    try {
      const res = await api.post('user/login');
      console.log('Login Success');
      commit('MUTATE_PROFILE', res.data);
      commit('MUTATE_LOGIN', true);
    } catch (error) {
      console.warn('Login Failed', error);
    }
  },

  // LINE快速登入
  async lineAuthorize({ commit }, config) {
    try {
      const res = await api.post('line/auth', config);
      return res.data;
    } catch (error) {
      console.error('failed', error);
      throw error;
    }
  },

  // LINE快速登入後，首次註冊填寫資料
  async userRegister({ commit }, config) {
    try {
      const res = await api.post('user/register', config);
      commit('SET_AUTH_DATA', {
        accessToken: res.data.access,
        refreshToken: res.data.refresh,
      });
      return res.data;
    } catch (error) {
      console.error('failed', error);
      commit('CLEAR_AUTH_DATA');
      throw error;
    }
  },

  // 使用者建立新訂閱訂單
  async userProfileControl({ commit }, config) {
    try {
      const res = await api.put('user/profile/control', config);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // 取得模型列表
  async getModels({ commit }, config) {
    try {
      const res = await api.put('models/list', config);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async getModelsDetail({ commit }, config) {
    try {
      const res = await api.put('models/validate', config);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async getUseModelHistory({ commit }, config) {
    try {
      const res = await api.put('models/history', config);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  
  // 產生 QR Code
  async qrcodeGenerate({ commit }, config) {
    try {
      // 將傳入的 config 當作 query parameters 傳遞
      // 例如 config 為 { url: 'https://xxx.com' }，請求會變成 qrcode/generate?url=https://xxx.com
      const res = await api.get('qrcode/generate', { params: config });
      return res.data;
    } catch (error) {
      throw error;
    }
  },
};